import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../../../app/guards'
import { taxRatesQueryOptions } from '../../../../../features/finance/queries'
import { EditRecurringPage } from '../../../../../features/finance/recurring-pages'

export const Route = createFileRoute('/_app/expenses/recurring/$recurringId/edit')({
  staticData: { crumb: 'expenseEdit' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'expenses.create'),
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(taxRatesQueryOptions)
  },
  component: EditRecurringPage,
})
